import { defineStore } from 'pinia'
import {HOME_ALL_DATA} from  '@/constants/piniaStoreNames'
import HomeAllData from '@/servers/home/HomeAllData'
import {HomeData} from '@/types/API'

type Ta = {
  data: HomeData | null
}

export const useHomeDataStore = defineStore(HOME_ALL_DATA, {
    state: (): Ta => {
      return {
        data: null
      }
    },

    actions: {
      async getHomeData(id?: number) {
        try {
          const res = await HomeAllData.getData(id)
          this.data = res.data
          return this.data
        } catch {
          return Promise.reject()
        }
      }
    }
  })
  